// extracted by mini-css-extract-plugin
module.exports = {"top_bar":"MobileAbsenceBlock_top_bar__1oDWQ"};